import { Component, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { ModalFormContainerComponent } from '../../ui/modal-form-container/modal-form-container.component';
import { GroupPickerComponent } from '../../organization/contacts/group-picker/group-picker.component';
import { ITag } from '../../../types/contactModule';

/**
 * Pick tags as message or campaign recipients. The choice is a draft
 * until confirmed: closing the dialog leaves the caller's selection as it was.
 */
@Component({
  selector: 'add-tags-modal',
  standalone: true,
  imports: [ModalFormContainerComponent, GroupPickerComponent],
  templateUrl: './add-tags-modal.component.html',
  styleUrl: './add-tags-modal.component.css',
})
export class AddTagsModalComponent implements OnChanges {
  @Input() title: string = 'Choose tags';
  @Input() open: boolean = false;
  @Input() selection: ITag[] = [];
  @Output() close = new EventEmitter();
  @Output() updateSelection = new EventEmitter<ITag[]>();

  /** The working copy shown in the picker. */
  draft: ITag[] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['open'] || changes['selection']) {
      this.draft = [...(this.selection || [])];
    }
  }

  onPick(items: ITag[]) {
    this.draft = items;
  }

  emitSelection() {
    this.updateSelection.emit([...this.draft]);
    this.closeModal();
  }

  closeModal() {
    this.close.emit();
  }
}
